/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {nthChildIterator, pxToEm, pxToEmWithBaseline} from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : RATING CODE : STYLES --------------- ++++++++++ */
export default theme => ({
    code: {
        fontSize: pxToEm(16),
        lineHeight: pxToEmWithBaseline({ value: 20 , fontSizeBaseline: 16 }),
        '& .codepiece': {
            '& .field': {
                marginTop: `${pxToEm(20)} !important`
            },
            '& p': {
                maxWidth: '588px'
            }
        },
        '& .copysnippetfield,.codemessage': {
            opacity: '0',
            animationName: 'fadeInUp',
            animationDuration: '.2s',
            animationFillMode: 'forwards',
            extend: nthChildIterator(100, .2, .1),
        },
        '& .codemessage': {
            // margin: replacePXinStringWithEM('55px 0'),
            maxWidth: pxToEmWithBaseline({ value: 772 , fontSizeBaseline: 16 }),
            marginTop: pxToEmWithBaseline({ value: 40 , fontSizeBaseline: 16 }),
            marginBottom: pxToEmWithBaseline({ value: 55 , fontSizeBaseline: 14 }),
            '&:last-child': { marginBottom: '0' },
            '& .message': { padding: '16px 43px 16px 32px' },
            '& .text': {
                fontSize: pxToEm(16),
                '& .highlight': { color: theme.color.primary.medium.swatch }
            }
        }
    }
});
